import styled from 'styled-components';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';
import { palette } from '@dev/ee-components';
import { TemplatesPreview } from '@dev/ee-modules';

import { SetToastPortalWrapper } from '@/store/toast/actions';
import useMobile from '@/services/hooks/useMobile';
import { ApplicationState } from '@/store';
import { getEditorTemplateObjectStore, getEditorTemplatePreviewStore } from '@/store/templateEditor/actions';
import { PreviewOverlayProps } from './interface';

const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: max-content;

    .MuiContainer-root {
        padding-top: 60px;
    }
`;

export const PreviewOverlay = (props: PreviewOverlayProps): JSX.Element => {
    const { isOpen, setShowTemplatePreview } = props;
    const dispatch = useDispatch();
    const browser = useSelector((state: ApplicationState) => state.browser);
    const templateObject = useSelector(getEditorTemplateObjectStore);
    const templatePreview = useSelector(getEditorTemplatePreviewStore);
    const isMobile = useMobile();
    const templateName = templateObject?.Name;

    useEffect(() => {
        isOpen && dispatch(SetToastPortalWrapper(true));
        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, [isOpen]);

    const templateWithExternalLinks = useMemo(
        () => templatePreview?.templateHtml?.replace?.(/<a(.*?)>/gi, '<a $1 target="_blank">'),
        [templatePreview.templateHtml]
    );
    return (
        <Portal>
            <MaterialDialog open={isOpen} fullScreen>
                <Overlay>
                    <Grid container justifyContent="center" style={{ padding: '0px 16px' }}>
                        <Grid item xs={12} sm={12} style={{ maxWidth: 1170, paddingBottom: 16 }}>
                            <TemplatesPreview
                                open
                                browser={browser}
                                isDrawerMenuFolded={false}
                                templateList={null}
                                templateHtml={templateWithExternalLinks}
                                templateName={templateName}
                                isMobile={isMobile}
                                onCloseClick={() => {
                                    setShowTemplatePreview(false);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
